import { FC } from 'react'
import { useInstrumentsLogic } from './Instruments.logic'
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import {
  INSTRUMENTS_OPTIONS,
  MAIN_OPTIONS,
  TInstrumentsProps,
} from './Instruments.types'

export const Instruments: FC<TInstrumentsProps> = (props) => {
  const logic = useInstrumentsLogic(props)

  // Combine main options and the rest, ensuring no duplicates
  const allOptions = [
    ...MAIN_OPTIONS,
    ...INSTRUMENTS_OPTIONS.filter((option) => !MAIN_OPTIONS.includes(option)),
  ]

  return (
    <Grid container spacing={1}>
      {allOptions.map((option, index) => (
        <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
          <FormControlLabel
            label={
              MAIN_OPTIONS.includes(option) ? (
                <Typography fontWeight="bold" fontSize="1.1rem">
                  {option}
                </Typography>
              ) : (
                option
              )
            }
            control={
              <Checkbox
                checked={logic.selectedOptions.includes(option)}
                onChange={() => logic.handleCheckboxChange(option)}
              />
            }
          />
        </Grid>
      ))}
    </Grid>
  )
}
